export const DATE_RANGE_OPTIONS = [
	{ value: 'today', text: 'Today' },
	{ value: 'month_to_date', text: 'Month to date' },
	{ value: 'last_7_days', text: 'Last 7 days' },
	{ value: 'last_30_days', text: 'Last 30 days' },
	{ value: 'last_60_days', text: 'Last 60 days' },
	{ value: 'last_90_days', text: 'Last 90 days' },
];

export const SORTABLE_COLUMNS = ['activity_date', 'buyer_dealership', 'payment_method', 'receivables', 'payables'];

export const DEFAULT_SORTING = {
	order_by: 'activity_date',
	direction: 'desc',
};

export const DEFAULT_QUERY = {
	page: 1,
	per_page: 25,
	filters: {
		keywords: '',
		date_range: null,
		payment_method: null,
		dealership_id: null,
		user_id: null,
	},
	sorting: DEFAULT_SORTING,
};

export const initialState = {
	records: [],
	loading: false,
	success: undefined,
	exportingCsv: false,
	metadata: {
		page: 1,
		page_count: 0,
		per_page: 25,
		total_count: 0,
	},
	errors: {
		dataErrorMessage: '',
		exportErrorMessage: '',
		dealershipsErrorMessage: '',
		usersErrorMessage: '',
		paymentMethodsErrorMessage: '',
	},
	dealershipOptions: {
		data: [],
		loading: false,
	},
	userOptions: {
		data: [],
		loading: false,
	},
	paymentMethodOptions: {
		data: [],
		loading: false,
	},
	query: DEFAULT_QUERY,
};

export const FILTERS_STORAGE_KEY = 'transactionsLedgerURLStorage';
export const SORTING_KEYS = ['order_by', 'direction'];
